import { useState, useCallback } from 'react';
import { apiClient, type SearchFilters } from '@/lib/api-client';
import type { Pattern } from '@/lib/supabase';

export function useSearch() {
  const [results, setResults] = useState<Pattern[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const search = useCallback(async (query: string, filters?: SearchFilters) => {
    if (!query || query.length < 2) {
      setResults([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const data = await apiClient.searchPatterns(query, filters);
      setResults(data.patterns);
    } catch (err) {
      setError(err as Error);
      setResults([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clear = useCallback(() => {
    setResults([]);
    setError(null);
  }, []);

  return {
    results,
    isLoading,
    error,
    search,
    clear,
  };
}
